<template>
  <v-data-table :footer-props="footerProps"
                :headers="headers"
                :items="statistics"
                :loading="loading"
                class="elevation-1">
    <template
      v-slot:item.totalAmount="{ item }"
    >
      {{ item.totalAmount | currency('$', 0, { thousandsSeparator: '.' }) }}
    </template>
    <template
      v-slot:item.totalBusinessFee="{ item }"
    >
      {{ item.totalBusinessFee | currency('$', 0, { thousandsSeparator: '.' }) }}
    </template>
    <template
      v-slot:item.totalProfit="{ item }"
    >
      {{ item.totalProfit | currency('$', 0, { thousandsSeparator: '.' }) }}
    </template>
  </v-data-table>
</template>

<script>
import eventsService from '@/services/eventsService.js'
import notifications from '@/libs/notifications.js'
export default {
  async created () {
    try {
      const companyId = this.$store.getters.companyUuid
      const appId = this.$store.getters.appUuid
      const token = this.$store.getters.token
      const eventId = this.$route.params.eventid
      this.loading = true
      this.statistics = await eventsService.getStatisticsTickets(token, companyId, appId, eventId)
      this.loading = false
    } catch (e) {
      notifications.error('Error obteniendo las estadísticas de tickets')
    }
  },
  computed: {
    headers () {
      return [
        {
          text: 'Ticket',
          align: 'start',
          value: 'titulo'
        },
        { text: this.$t('general.soldTickets'), value: 'vendidas' },
        { text: this.$t('general.checkedIn'), value: 'checkeadas' },
        { text: 'Total', value: 'totalAmount' },
        { text: this.$t('general.businessFee'), value: 'totalBusinessFee' },
        // { text: this.$t('general.gatewayFee'), value: 'totalGatewayFee' },
        { text: this.$t('general.totalProfit'), value: 'totalProfit' }
      ]
    }
  },
  data: () => ({
    footerProps: {
      'items-per-page-options': [50, 100, 200]
    },
    loading: false,
    statistics: []
  })
}
</script>
